import { AnalyticsEvent, GTMEventData } from "@hermes/utils/analytics";

interface SearchGridEventData {
    eventaction: "WithResultsGrid";
    eventlabel?: string;
}
/**
 * This class is used in order to send analytics events from search bar in header
 */
export class SearchGridEvent implements AnalyticsEvent<GTMEventData> {
    /**
     * Event name expected for every uaevent event
     */
    public name: string = "uaevent";

    /**
     * Mandatory parameter of AnalyticsEvent.
     */
    public eventData = {};

    /**
     * Event's data from component to format correctly variation-click event
     */
    public searchGridData?: SearchGridEventData;

    constructor(data?: SearchGridEventData) {
        this.searchGridData = data;
    }
    /**
     * Overload formatForGTM of inherited class
     * Return formatter for eventaction key
     */
    public formatForGTM(): GTMEventData {
        return {
            event: this.name,
            eventcategory: "Search",
            eventaction: this.searchGridData?.eventaction,
            eventlabel: this.searchGridData?.eventlabel,
        };
    }
}
